import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { DateSchema } from 'yup';

export const DateValidation = (): DateSchema => {
  const { t } = useTranslation('form');
  return Yup.date().typeError(t('INVALID_DATE'));
};

/**
 * DateSchema.INVALID_DATE is a common Date object.
 * Therefore the typing of `additionalOnChange` in the FormDatePicker would be string | Date.
 * This is misleading because in this case `Date` means "everything that is definitely not a Date".
 * Here we create a type that is reserved for INVALID_DATE and pretty much only changes the name of the typing.
 * We add a property, so that TypeScript does not allow us to assign a normal date to InvalidDate, just because the type signature matches.
 * The property won't exist on the exported INVALID_DATE, which is why it's called "DO_NOT_USE"
 */
export type InvalidDate = typeof DateSchema.INVALID_DATE & {
  DO_NOT_USE: true;
};

export const INVALID_DATE: InvalidDate = DateSchema.INVALID_DATE as InvalidDate;

export const isValidDate = (date?: Date | InvalidDate): date is Date =>
  !!date && date !== INVALID_DATE;
